import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Maryland Kush · Cannabis Insights</p>
        <h1>Welcome to Maryland Kush</h1>
        <p className="lede">
          Your go-to source for the latest news and information on cannabis policy and culture in Maryland.
          Stay informed about local laws, legal status updates, and educational resources.
        </p>
        <div className="cta-row">
          <a href="/news" target="_self">
            Latest News
          </a>
          <a href="/guides" target="_self" className="secondary">
            Educational Guides
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Stay updated on the latest changes in cannabis legislation and regulations affecting Maryland residents.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear and concise information about the legal status of cannabis in your area, including usage and possession laws.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Explore our comprehensive guides and articles designed to educate the community about cannabis culture and policy.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;